var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasIdentityRecordsData
    ? _c(
        "q-timeline",
        {
          staticClass: "lead-identity-history-timeline",
          attrs: { color: "secondary", layout: "dense", side: "right" }
        },
        _vm._l(_vm.sortedIdentityRecordsByDate, function(
          identityRecord,
          identityIndex
        ) {
          return _c(
            "q-timeline-entry",
            { key: identityIndex },
            [
              _c("SdDatetime", {
                staticClass: "q-timeline-subtitle",
                attrs: {
                  value: identityRecord.changed_at,
                  timezone: _vm.moment.tz.guess()
                }
              }),
              _c(
                "div",
                { staticClass: "position-relative" },
                [
                  _vm.shouldShowInquiryLink(identityRecord)
                    ? _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "app.inquiries.timeline",
                              params: { id: identityRecord.related_inquiry_id }
                            }
                          }
                        },
                        [
                          _c(
                            "q-chip",
                            {
                              staticClass: "inquiry-link round-borders",
                              attrs: {
                                icon: "library_books",
                                "text-color": "blue-3",
                                dense: ""
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "inquiry-link-id-text" },
                                [
                                  _vm._v(
                                    "\n            Inquiry ID:\n            "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "inquiry-link-text-id" },
                                    [
                                      _vm._v(
                                        "#" +
                                          _vm._s(
                                            identityRecord.related_inquiry_id
                                          )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "lead-identity-history-timeline-list round-borders border-color"
                    },
                    _vm._l(_vm.identifyHistoryFieldsMapping, function(
                      label,
                      field_name
                    ) {
                      return identityRecord[field_name]
                        ? _c("li", {
                            key: field_name,
                            staticClass:
                              "lead-identity-history-timeline-list-item border-color",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.generateIdentityRecordText(
                                  identityRecord[field_name],
                                  label
                                )
                              )
                            }
                          })
                        : _vm._e()
                    })
                  )
                ],
                1
              ),
              _c("div", { attrs: { slot: "title" }, slot: "title" })
            ],
            1
          )
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }